import { DateHelper } from '../date/index.js';
import Debug from 'debug';
import { Utility } from '../../utility/index.js';
import _ from 'lodash';
const debug = Debug(`knack.core.helpers.entry.formatField`);
export const formatField = (entry, field, format, options, val) => {
    const vals = {};
    const key = field.key;
    if (typeof val == `undefined`) {
        val = entry.values[`${key}_raw`] || entry.values[key]; // check for raw in case this entry was already formatted
    }
    let formatted = null;
    // add date equations key for later raw processing
    if (field.type == `equation` && format != `html`) {
        const type = Utility.getSolrType(`equation`, field.format);
        debug(`returned solr type:`, type);
        // this helps formatValues determine which equation fields may need to be formatted prior to returning to the client
        if (type === `date`) {
            debug(`pushing ${field.key} to entry.date_equations due to returned solr type being date`);
            entry.date_equations.push(field);
        }
    }
    if (val != null) {
        // raw formatting
        if (format === `raw` || format === `both`) {
            switch (field.type) {
                case `currency`:
                    val = Knack.formatNumber(val, {
                        precision: 2,
                        show_commas: true
                    });
                    break;
                case `date_time`:
                    val = DateHelper.formatDateRaw(val, field.format);
                    break;
                case `number`:
                    // val = Knack.formatNumber(val, field.format, true);  // removed this becuase it was formating decimals for percentages which was affecting the later format option below .6665 would get chopped to .67
                    break;
                case `password`:
                    val = `**********`;
                    break;
            }
        }
        // raw format only, no HTML formatting required
        if (format === `raw`) {
            vals[key] = val;
            // html formatting
        }
        else {
            // let's add thumbs if they exist but no thumb_key is set
            if (!options.exporting && field.type === `image` && field.format /*&& field.format.source != 'url'*/ && field.format.thumbs && field.format.thumbs.length) {
                _.each(field.format.thumbs, function (thumb) {
                    vals[`${key}:${thumb.key}`] = Knack.formatImage(entry.req, val, thumb.key);
                });
            }
            // let's set the connection separator if coming from a view
            if (field.type === `connection`) {
                if (!field.format) {
                    field.format = {};
                }
                let conn_separator = `new_line`;
                if (options[field.key] && options[field.key].conn_separator) {
                    conn_separator = options[field.key].conn_separator;
                }
                field.format.separator = conn_separator;
                if (options[field.key] && options[field.key].conn_link) {
                    field.format.conn_link = options[field.key].conn_link;
                }
            }
            // the builder uses this to just show image thumbs in the records tables
            if (field.type === `image` && options.image_thumbs) {
                formatted = Knack.formatImage(entry.req, val, `thumb`);
            }
            else {
                formatted = Knack.formatField(entry.req, field, val, format);
            }
            // When exporting, this removes the &nbsp; chars
            // that get set as a result of Knack.format[Currency, Number] (these also get called by Knack.formatField)
            if (options.exporting && typeof formatted === `string` && (field.type === `currency` || field.type === `number` || (field.type === `equation` && field.format.equation_type === `numeric`))) {
                formatted = formatted.replace(`&nbsp;`, ` `);
            }
            // set formatted
            vals[key] = formatted;
            // add raw
            if (format === `both` || entry.req.format_raw) {
                vals[`${key}_raw`] = val;
            }
        }
    }
    else {
        vals[key] = ``;
    }
    return vals;
};
